import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const InlineFilterLoading: React.FC = () => {
  return (
    <Wrapper data-testid="filterFlyoutLoadingView">
      <FilterSectionElements>
        <SkeletonBlock disableSpaceBelow $width="18%" $height="32px" />
        <SkeletonBlock disableSpaceBelow $width="18%" $height="32px" />
        <SkeletonBlock disableSpaceBelow $width="18%" $height="32px" />
        <SkeletonBlock disableSpaceBelow $width="18%" $height="32px" />
      </FilterSectionElements>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
`;

const FilterSectionElements = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  margin-bottom: 1.875rem;
`;
